import { delay, takeEvery, call, select } from 'redux-saga/effects';
import * as api from '../../services/payment_transaction/api_payment_transaction';
import * as apiCommon from '../../services/apiCommon';
import * as SagasType from '../../constants/constant_saga_types';
import * as SagaCommon from '../sagasCommon';
import { getLocalDatetime } from '../../utils/local_date';

export function* fetchPaymentTransactionById(feathersApp) {
  yield takeEvery(SagasType.FETCH_PAYMENT_TRANSACTION_BY_ID, callFetchPaymentById, feathersApp);
}

function* callFetchPaymentById(feathersApp, action) {
  try {
    const { user } = yield select();
    const { id } = action;
    yield SagaCommon.showProgressDataById();

    if (id) {
      const params = { id, user };
      const doc = yield call(api.fetchPaymentTransactionById, feathersApp, params);

      if (doc.customer && doc.customer.loyalty_member) {
        const loyaltyMovement = yield call(apiCommon.getDoc, feathersApp, {
          id,
          docType: 'loyalty_movement/payment',
        });

        doc.loyalty_movement = loyaltyMovement;
      }
      yield SagaCommon.doneDataById(doc);
    } 
  } catch (error) {
    yield SagaCommon.showErrorDataById(error, true);
  }
}

export function* fetchAllPaymentTransaction(feathersApp) {
  yield takeEvery(SagasType.FETCH_LIST_PAYMENT_TRANSACTION, callFetchAllPaymentTransaction, feathersApp);
}

function* callFetchAllPaymentTransaction(feathersApp, action) {
  try {
    yield delay(250);
    const { silent, filters } = action;
    yield SagaCommon.showProgressListTable( silent );
    // Override values of range dates (dateFrom and dateTo) for use of local dates
    const { dateFrom, dateTo } = filters;
    filters.dateFromLocal = dateFrom ? getLocalDatetime(dateFrom) : undefined;
    filters.dateToLocal = dateTo ? getLocalDatetime(dateTo) : undefined;
    delete filters.dateFrom;
    delete filters.dateTo;

    const dataParams = {
      filters,
      list_type: 'payment'
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(SagaCommon.doneListTable, { rows: tableData.data, total_rows: tableData.total });
  } catch (error) {
    yield SagaCommon.showErrorListTable(error);
  }
}